export default __webpack_public_path__ + "static/media/web.gradissue.online.pauley.DR.2655e431.jpg";